import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Contact from "@/components/site/Contact";

export default function Landing() {
  return (
    <main className="relative min-h-screen bg-[#030712] text-white overflow-hidden font-body antialiased">
      {/* Ambient background accents */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-[-10%] left-[-10%] h-[520px] w-[520px] rounded-full bg-[#1E3A8A] opacity-[0.18] blur-[140px]" />
        <div className="absolute bottom-[-20%] right-[-10%] h-[600px] w-[600px] rounded-full bg-[#2563EB] opacity-[0.12] blur-[160px]" />
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.6) 1px, transparent 0)",
            backgroundSize: "44px 44px",
          }}
        />
      </div>

      <Header />
      <Hero />
      <Contact />
    </main>
  );
}
